<template>
    <my-dialog :title="title" :visible.sync="showDetailVisible" @close="closeDialog()" :close-on-click-modal="false"
        :modal="false" width="90%">
        <div class="main_bg">
            <div class="item_info border_Green">
                <el-descriptions :column="3" :border="true" title="备用金信息" :label-width="120">
                    <el-descriptions-item label="所属门店">
                        <span class="descriptions-item-value">{{ dtlInfo.storeName }}</span>
                    </el-descriptions-item>
                    <el-descriptions-item label="申请人">
                        <span class="descriptions-item-value">{{ dtlInfo.creator }}</span>
                    </el-descriptions-item>
                    <el-descriptions-item label="申请时间">
                        <span class="descriptions-item-value">{{ dtlInfo.createTime }}</span>
                    </el-descriptions-item>
                    <el-descriptions-item label="单号">
                        <span class="descriptions-item-value">{{ dtlInfo.code }}</span>
                    </el-descriptions-item>
                    <el-descriptions-item label="费用类型">
                        <span class="descriptions-item-value">{{ dtlInfo.typeStr }}</span>
                    </el-descriptions-item>
                    <el-descriptions-item label="状态">
                        <span class="descriptions-item-value">{{ dtlInfo.stateStr }}</span>
                    </el-descriptions-item>
                    <el-descriptions-item label="金额">
                        <span class="descriptions-item-value">{{ dtlInfo.money }}</span>
                    </el-descriptions-item>
                    <el-descriptions-item label="内容" :span="2">{{ dtlInfo.content }}</el-descriptions-item>
                    <el-descriptions-item label="是否确认">
                        <span class="descriptions-item-value">
                            <el-tag v-if="dtlInfo.isConfirm" type="success">已确认</el-tag>
                            <el-tag v-else type="danger">未确认</el-tag>
                        </span>
                    </el-descriptions-item>
                    <el-descriptions-item label="确认人">
                        <span class="descriptions-item-value">{{ dtlInfo.confirmUserName }}</span>
                    </el-descriptions-item>
                    <el-descriptions-item label="确认时间">
                        <span class="descriptions-item-value">{{ dtlInfo.confirmTime }}</span>
                    </el-descriptions-item>
                    <el-descriptions-item label="是否审核" v-if="dtlInfo.money >= 200">
                        <span class="descriptions-item-value">
                            <el-tag v-if="dtlInfo.isAudit" type="success">已审核</el-tag>
                            <el-tag v-else type="danger">未审核</el-tag>
                        </span>
                    </el-descriptions-item>
                    <el-descriptions-item label="审核人" v-if="dtlInfo.money >= 200">
                        <span class="descriptions-item-value">{{ dtlInfo.auditUserName }}</span>
                    </el-descriptions-item>
                    <el-descriptions-item label="审核时间" v-if="dtlInfo.money >= 200">
                        <span class="descriptions-item-value">{{ dtlInfo.auditTime }}</span>
                    </el-descriptions-item>
                    <el-descriptions-item label="是否支付">
                        <span class="descriptions-item-value">
                            <el-tag v-if="dtlInfo.isPay" type="success">已支付</el-tag>
                            <el-tag v-else type="danger">未支付</el-tag>
                        </span>
                    </el-descriptions-item>
                    <el-descriptions-item label="财务确认人">
                        <span class="descriptions-item-value">{{ dtlInfo.payUserName }}</span>
                    </el-descriptions-item>
                    <el-descriptions-item label="财务确认时间">
                        <span class="descriptions-item-value">{{ dtlInfo.payTime }}</span>
                    </el-descriptions-item>
                </el-descriptions>
            </div>

            <div class="item_info border_Blue">
                <div class="item_title">
                    <div class="title">操作记录</div>
                    <div class="btnDiv">
                    </div>
                </div>
                <operationLog ref="operationLog"></operationLog>
            </div>
        </div>
        <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="closeDialog()">取消</el-button>
        </div>
    </my-dialog>
</template>

<script>
import {
    GetStoreCostDtl
} from "@/api/storeCostApi.js";
import operationLog from "@/views/system/operationLog/businessOperationLog.vue";
export default {
    props: {
        storeList: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            showDetailVisible: false,
            loading: false,
            title: "备用金消费详情",
            dtlInfo: {
            }
        };
    },
    created() { },
    mounted() { },
    components: {
        operationLog,
    },
    methods: {
        // 展示详情
        showDetail(keyId) {
            this.dtlInfo = {};
            GetStoreCostDtl({
                keyId: keyId
            }).then(res => {
                if (res.code == 1) {
                    this.dtlInfo = res.data;
                    this.title = "备用金消费详情";
                } else {
                    this.$message.error(res.msg);
                }
            });
            this.showDetailVisible = true;
            this.$nextTick(() => {
                this.$refs.operationLog.showOperationLog(keyId);
            });
        },
        // 关闭详情弹出框
        closeDialog() {
            this.dtlInfo = {};
            this.showDetailVisible = false;
        },
    },
};
</script>
<style scoped>
.main_bg {
    padding: 10px;
    margin-top: -15px;
}

.formDiv {
    border: 1px solid #e9e7e7;
    padding: 10px;
    border-radius: 5px;
}

.item_info {
    border-left: 5px solid #55aaff;
    padding: 5px 10px;
    border-radius: 5px;
    margin-bottom: 15px;
    border: 2px solid #e9e7e7;
}

.border_Blue {
    border-left: 5px solid #55aaff;
}

.border_Warningcolor {
    border-left: 5px solid #ff9900;
}

.border_Green {
    border-left: 5px solid #00cc66;
}

.item_title {
    display: flex;
    width: 100%;
    font-weight: 700;
    font-size: 1rem;
    margin-bottom: 10px;
    justify-content: space-between;

    .title {
        display: inline-block;
        unicode-bidi: isolate;
    }

    .btnDiv {
        display: block;
        unicode-bidi: isolate;
        word-break: break-all;
    }
}

.descriptions-item-value {
    display: inline-block;
    min-width: 100px;
    text-align: left;
}
</style>